import React from 'react'

const ArrowDownIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size ?? 20} height={props?.size ?? 20} viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.69344 7.09327C3.91808 6.83119 4.31265 6.80084 4.57472 7.02548L10.0013 11.6768L15.4279 7.02548C15.69 6.80084 16.0845 6.83119 16.3092 7.09327C16.5338 7.35535 16.5035 7.74991 16.2414 7.97455L10.4081 12.9745C10.174 13.1752 9.82862 13.1752 9.59457 12.9745L3.76124 7.97455C3.49916 7.74991 3.46881 7.35535 3.69344 7.09327Z" fill={props?.color ?? 'var(--primary)'} />
        </svg>
    )
}

export default ArrowDownIcon